import { render, staticRenderFns } from "./ServicesNavigation.vue?vue&type=template&id=56f78593&"
import script from "./ServicesNavigation.vue?vue&type=script&lang=js&"
export * from "./ServicesNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports